
export const IS_ADMIN = 'IS_ADMIN'
export const IS_LOGIN = 'IS_LOGIN'
export const USER_INFO = 'USER_INFO'
export const HOME_URL = 'HOME_URL'

